import React from "react";

const Footer = () => {
  return (
    <div className="container-fluid py-5 white-color black-bg">
      <div className="container text-center">
        © Baba Thiam - Tous droits réservés |{" "}
        <a
          target="blank"
          href="https://www.linkedin.com/in/baba-thiam/"
          className="blue-color text-decoration-none"
        >
          LinkedIn
        </a>{" "}
        |{" "}
        <a
          target="blank"
          href="https://x.com/Babathiam01"
          className="blue-color text-decoration-none"
        >
          Twitter/X
        </a>{" "}
        |{" "}
        <a
          target="blank"
          href="mailto:babathiam0000@gmail.com"
          className="blue-color text-decoration-none"
        >
          Email
        </a>
      </div>
    </div>
  );
};

export default Footer;
